import * as moment from "moment";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";

export function FixDates(): MethodDecorator {
  return function (target: Function, key: string, descriptor: any) {

    const originalMethod = descriptor.value;

    descriptor.value = function (...args: any[]) {
        const modifiedArgs = DatesToString(args);
        const result = originalMethod.apply(this, modifiedArgs);
      return (<Observable<any>>result).pipe(map(v => ReplaceDates(v)));
    }

    return descriptor;
  }
}

export function ReplaceDates(v: object) {
  if (typeof (v) == 'string' || typeof (v) == 'number' || typeof (v) == 'function') {
    return v;
  }
  if (Array.isArray(v)) {
    for (let i = 0; i < v.length; i++) {
      ReplaceDates(v[i]);
    }
    return v;
  }
  for (let key in v) {
    if ((key.toLowerCase().endsWith("date") || key.toLowerCase().endsWith("time")) && v[key]) {
      //console.log(key + ' ' + v[key] + ' what ' + moment(v[key]).format("YYYY-MM-DDTHH:mm:ss"))
      v[key] = moment(v[key]).format("YYYY-MM-DDTHH:mm:ss[Z]");
    } else {
      if (key != 'actionPlans') {
        ReplaceDates(v[key]);
      }
    }
  }
  return v;
}

export function DatesToString(v: any) {
  if (typeof (v) != 'object' || moment.isMoment(v) || !v) {
    return v;
  }
  if (Array.isArray(v)) {
      const resArray = [];
      for (let i = 0; i < v.length; i++) {
      resArray.push(DatesToString(v[i]));
    }
    return resArray;
  }
    const objRes = {};
    for (let key in v) {
    if ((key.toLowerCase().endsWith("date") || key.toLowerCase().endsWith("time")) && v[key] && moment(v[key]).isValid()) {
      //console.log(key + ' ' + v[key])
        const mmt = (typeof (v[key]) == 'string' && v[key].endsWith('Z')) ? moment.utc(v[key]) : moment(v[key]);
        if (mmt.year() < 1900) {
        objRes[key] = moment().format('YYYY-MM-DDT00:00:00');
      } else {
        objRes[key] = mmt.format('YYYY-MM-DDTHH:mm:ss');
      }
    } else {
      objRes[key] = DatesToString(v[key]);
    }
  }
  return objRes;
}
